import { getPagesCount } from '../../shared/utils/get-pages-count';
export function generateEntities(data, property) {
    if (property === void 0) { property = '_id'; }
    if (!data)
        return {
            ids: [],
            entities: {},
            totalPages: 1,
            totalCount: 0
        };
    var items = data.results;
    var ids = items.map(function (p) { return p[property]; });
    var entities = items.reduce(function (itemsMap, item) {
        var _a;
        return Object.assign(itemsMap, (_a = {},
            _a[item[property]] = item,
            _a));
    }, {});
    return {
        ids: ids,
        entities: entities,
        totalPages: getPagesCount(data.totalCount),
        totalCount: data.totalCount
    };
}
export function parseEntities(entities) {
    if (!entities)
        return [];
    return entities && Object.keys(entities).map(function (id) { return entities[id]; });
}
